// Stash the page's map data so the /map/:id tab can render without a saved ClientQuery.
export const openMapInNewTab = (id, { portOperation, fleetList, portDistanceResponse }) => {
  if (!id) return;
  try {
    localStorage.setItem(
      `mapData_${id}`,
      JSON.stringify({ portOperation, fleetList, portDistanceResponse })
    );
  } catch (e) {}
  window.open(`/map/${id}`);
};

export const readStoredMapData = (id) => {
  try {
    return JSON.parse(localStorage.getItem(`mapData_${id}`)) || null;
  } catch (e) {
    return null;
  }
};
